module.exports = __webpack_public_path__ + "static/media/nurturing-growth.d18df692.jpg";